import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * ProtectedRoute
 *
 * MarginPro is still in development — every page except /login should
 * require an authenticated session (see App.jsx). This
 * wraps those routes: while the stored token is being validated it
 * renders nothing but a small loading state (avoids a flash of protected
 * content), and once resolved it either renders the nested route via
 * <Outlet /> or bounces to /login, remembering where the user was headed
 * so we can return them there after they sign in.
 */
const ProtectedRoute = () => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="auth-gate-loading" role="status" aria-live="polite">
        <span className="auth-gate-loading__spinner" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
